import classNames from 'classnames/bind'

// Components
import { SearchBar } from '../../../shared/livemallclub/SearchBar'
import SearchResults from '../Explore/components/Preferences/components/SearchResults'

// Libs
import useLiveMallSearch from '@/hooks/useLiveMallSearch'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

const SearchComponent = () => {
  const { handleSubmit, inputRef, clearInput } = useLiveMallSearch()
  return (
    <div className={cx('search')}>
      <div className={cx('search-bar-wrapper')}>
        <SearchBar inputRef={inputRef} onSubmit={handleSubmit} onClear={clearInput} />
      </div>
      <SearchResults />
    </div>
  )
}

export default SearchComponent
